import callApi from "@repo/next-shared/utils/api";
import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { Color } from "@/types/colors";

export async function getColors() {
  return await callApi({ path: "/catalog/color", method: "GET" });
}

export function useColorsBase(select: any): any {
  return useQuery({
    queryKey: ["colors"],
    queryFn: () => getColors(),
    select,
    staleTime: 60000 * 60,
  });
}

export function useColors(): UseQueryResult<Color[], any> {
  return useColorsBase((colors: Color[]) => colors);
}
